import { createNullCache } from '@algolia/cache-common';
import algoliasearch, { SearchIndex } from 'algoliasearch';
import { useEffect, useRef, useState } from 'react';

export type SearchProduct = {
  uuid: string | null;
  description: string | null;
  invoice_description: string | null;
  price: number | null;
  brand: string | null;
  type: string | null;
  size: string | null;
  note: string | null;
  cache_price: number | null;
  page_url: string | null;
  thumbnails: string | null;
  web_variant: string | null;
  web_desc: string | null;
};

export const searchClient = algoliasearch(
  "6MZVQM3HRB",
  "7a35d4baa9192ca440c2a1bb6fe79705",
  { requestsCache: createNullCache(), responsesCache: createNullCache() }
);

export const numberLocale = "tr";

export const accountsSearch = searchClient.initIndex("accounts");
export const productsSearch = searchClient.initIndex("products_v2");
export const formsSearch = searchClient.initIndex("forms_v2");

export const useSearch = (index: SearchIndex, query: string, maxHits = 15) => {
  const [searchHits, setSearchHits] = useState<any[]>([]);
  const [remainingResults, setRemainingResults] = useState(0);
  const [searchLoading, setSearchLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const searchHash = useRef<number>();

  useEffect(() => {
    const hash = Date.now() + Math.random();
    searchHash.current = hash;

    setSearchLoading(!!query);

    if (!query) {
      setSearchHits([]);
      return;
    }

    setTimeout(() => {
      if (searchHash.current !== hash || !query) return;

      index.search(query, { hitsPerPage: maxHits }).then((result) => {
        if (searchHash.current !== hash) return;
        if (!hasSearched) setHasSearched(true);

        setSearchLoading(false);
        setSearchHits(result.hits);
        setRemainingResults(result.nbHits - result.hits.length);
      });
    }, 200);
  }, [
    query,
    index,
    hasSearched,
    searchHash,
    setSearchHits,
    setRemainingResults,
  ]);

  return [searchHits, searchLoading, hasSearched, remainingResults] as const;
};
